import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_495 implements Validator {

    public static id = 'CTRL_495';
    private message = 'error.ctr_495';


    public LOG: LogService = new LogService(CTRL_495);


    validate(form: any, map) {


        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_495.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const firstChampNameWithStepId = map.get(ctrl.value.rgCtrls.firstChamp);
                const secondChampNameWithStepId = map.get(ctrl.value.rgCtrls.secondChamp);
                const thirdChampNameWithStepId = map.get(ctrl.value.rgCtrls.thirdChamp);
                const firstChampCtrl = form.controls[firstChampNameWithStepId];
                const secondChampCtrl = form.controls[secondChampNameWithStepId];
                const thirdChampCtrl = form.controls[thirdChampNameWithStepId];
                if ((!firstChampCtrl.value  && secondChampCtrl.value  && thirdChampCtrl.value ) || (firstChampCtrl.value && !secondChampCtrl.value && !thirdChampCtrl.value)) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
